<template>
  <div style="overflow-y: auto" 
    v-if="isPermittedAll([
        'CallsGetAll'
    ]) && isMobile">
      <v-expansion-panels multiple v-model="expanded" class="custom-expansion">  
        <v-expansion-panel
          v-for="(log, i) in mobileFilteredCallLog"
        >
          <v-expansion-panel-header>
            <div class="d-flex justify-center">
              <div  v-if="expanded.includes(i) === false">
                <div class="mb-2">
                  <b >{{ log.Customer.CustomerName }}</b>
                </div>

                <div>{{ log.CallStartUtc | dateAtTime }}</div>
              </div>
              <div class="customer-status-dot-cell ml-auto align-self-center">
                <span
                  class="customer-status-dot mr-1" 
                  :class="log.Customer.CustomerStatusColor.CustomerStatusColorName">
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <div>
                <b>Customer</b>
                <p>{{ log.Customer.CustomerName }}</p> 
              </div>
              <div>
                <b>Location</b>
                <p>{{ log.Customer.CustomerCity }}</p> 
              </div>
              <div>
                <b>Support Tech</b>
                <p>{{ log.LastModifiedBy.TransactUser.UserGivenName  }}</p> 
              </div>
              <div class="d-flex">
                <div>
                  <b>Opened</b>
                  <p>{{ log.CallStartUtc | dateAtTime }}</p> 
                </div>
                <v-btn
                  @click="isPermittedAll([
                    'CallsGetByID'
                  ]) && openCallLog(log.CallID)"
                  type="button"
                  color="primary"
                  outlined
                  class="ml-auto align-self-center">
                  View
                </v-btn>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  
  <v-data-table
    v-else-if="isPermittedAll([
      'CallsGetAll'
    ])"
    id="call-log-table"
    class="page-table"
    :headers="callLogFields"
    mobile-breakpoint="-1"
    :items="callLog"
    item-key="CallID"
    dense
    disable-pagination
    hide-default-footer
    fixed-header
    :options="{
      sortBy: ['CallStartUtc'],
      sortDesc: [true],
      rowsPerPage: -1,
    }">
    <template
      v-slot:item="row">
      <tr
        class="pointer"
        :class="{
          'hidden-table-row': row.item.CallIsDeleted || row.item.Customer.CustomerIsDeleted
        }"
        @click="isPermittedAll([
          'CallsGetByID'
        ]) && openCallLog(row.item.CallID)">
        <td>
          {{row.item.Customer.CustomerName}}
          <span v-if="row.item.Customer.CustomerIsDeleted">(Hidden)</span>
        </td>
        <td>
          {{row.item.Customer.CustomerCity}}, {{row.item.Customer.CustomerState}}
        </td>
        <td>{{row.item.LastModifiedBy.TransactUser.UserGivenName}}</td>
        <td>{{row.item.CallStartUtc | dateAtTime}}</td>
        <td class="customer-status-dot-cell">
          <div class="d-flex align-center">
            <span
              class="customer-status-dot mr-1"
              :class="row.item.Customer.CustomerStatusColor.CustomerStatusColorName">
            </span>
          </div>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'CallLogTable',
  props: ['callLog'],
  data() {
    return {
      expanded: [],
      callLogFields: [
        {
          text: 'Customer',
          value: 'Customer.CustomerName',
        },
        {
          text: 'Location',
          value: 'Customer.CustomerCity',
        },
        {
          text: 'Support Tech',
          value: 'LastModifiedBy.TransactUser.UserGivenName',
        },
        {
          text: 'Opened',
          value: 'CallStartUtc',
        },
        {
          text: '',
          value: 'Customer.CustomerStatusColor.CustomerStatusColorName',
        },
      ],
    };
  },
  methods: {
    openCallLog(CallID) {
      this.$router.push({ name: 'CallLogPage', params: { CallID } });
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    mobileFilteredCallLog() {
      return this.callLog.filter(x => (x.CallIsDeleted === false && x.Customer.CustomerIsDeleted === false))
        .sort((a, b) => b.CallStartUtc.localeCompare(a.CallStartUtc));
    }
  },
  created() {
    this.$store.dispatch('getCalls');
    this.$store.dispatch('getOpenCalls');
  },
};
</script>
